var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    viewBox: "0 0 51 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0349121,
    y: 0.646973,
    width: 50,
    height: 40,
    rx: 20,
    fill: "#323A73"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_1023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2449 20.647H31.9122M20.2449 20.647L18.3887 26.2155C18.3612 26.2895 18.3556 26.3699 18.3724 26.4471C18.3892 26.5242 18.4279 26.595 18.4837 26.6508C18.5396 26.7067 18.6103 26.7453 18.6875 26.7621C18.7646 26.779 18.845 26.7733 18.9191 26.7458L31.9122 20.647M20.2449 20.647L18.3887 15.0786C18.3612 15.0045 18.3556 14.9241 18.3724 14.847C18.3892 14.7698 18.4279 14.6991 18.4837 14.6432C18.5396 14.5874 18.6103 14.5487 18.6875 14.5319C18.7646 14.515 18.845 14.5207 18.9191 14.5482L31.9122 20.647",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_1023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(16.0349 11.647)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.295e12a89d174f3e99027dab61b3a51d.svg";
export { ForwardRef as ReactComponent };